import React from 'react';

import logo from './Image/Logo.svg';

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 *
 */

//-----------------------|| LOGO SVG ||-----------------------//

const Logo = () => {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <img src={logo} alt="Dhwarco" width="100%" height="100%" />
        </div>
    );
};

export default Logo;
